//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import { BodyErrorText, MetatagText } from '@components/atoms/text/Text';
import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';
import { DropdownMenu } from '@components/primitives/dropdown-menu/DropdownMenu';
import {
  MediaSource,
  MediaSourceSection,
} from '@content-drawer/filters/useMediaSourcesSections';

export interface MediaSourcesDropdownSectionProps {
  section: MediaSourceSection;
  selected: MediaSource;
  onSelect: (source: MediaSource) => void;
}

export const MediaSourcesDropdownSection = ({
  section,
  selected,
  onSelect,
}: MediaSourcesDropdownSectionProps) => {
  return (
    <>
      <DropdownMenu.Label>
        <MetatagText>{section.label}</MetatagText>
      </DropdownMenu.Label>
      <DropdownItems>
        {section.sources.map((source) => (
          <DropdownMenu.Item key={source.id} onClick={() => onSelect(source)}>
            {source.tooltip && (
              <SmallTooltip
                placement='left'
                target={<>{source.label}</>}
                content={source.tooltip}
              />
            )}
            {!source.tooltip && source.label}
            {selected.id === source.id && <DropdownMenu.SelectedIcon />}
          </DropdownMenu.Item>
        ))}
      </DropdownItems>
      {section.sources.length === 0 && (
        <DropdownMenu.Label>
          <BodyErrorText>No results found.</BodyErrorText>
        </DropdownMenu.Label>
      )}
    </>
  );
};

const DropdownItems = styled.div(
  ({ theme }) => `
    max-height: ${theme.smallMeasure};
    overflow-y: auto;
  `,
);
